'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Email$() {
  this.c5F = null;
  this.c5G = false;
  this.c5D = null;
  this.c5E = false;
  this.c5J = null;
  this.c5K = false;
  this.c5H = null;
  this.c5I = false;
  this.c5z = null;
  this.c5A = false;
  this.c5B = null;
  this.c5C = false;
  this.c5L = null;
  this.c5M = false;
  this.c5y = null;
  $n_Lpresto_types$Email$ = this;
  this.c5y = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_s_util_matching_Regex__T__sci_Seq__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_matching_Regex(), "^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\\.)+[A-Za-z]{2,}$", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
}
export { $c_Lpresto_types$Email$ as $c_Lpresto_types$Email$ };
$p = $c_Lpresto_types$Email$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Email$;
/** @constructor */
function $h_Lpresto_types$Email$() {
}
export { $h_Lpresto_types$Email$ as $h_Lpresto_types$Email$ };
$h_Lpresto_types$Email$.prototype = $p;
$p.p8 = (function() {
  if ((!this.c5G)) {
    this.c5F = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c5G = true;
  }
  return this.c5F;
});
$p.cJ = (function() {
  if ((!this.c5E)) {
    this.c5D = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c5E = true;
  }
  return this.c5D;
});
$p.sD = (function() {
  if ((!this.c5K)) {
    this.c5J = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c5K = true;
  }
  return this.c5J;
});
$p.pa = (function() {
  if ((!this.c5I)) {
    this.c5H = new $c_Lpresto_types$Email$$anon$68(this);
    this.c5I = true;
  }
  return this.c5H;
});
$p.crt = (function() {
  if ((!this.c5A)) {
    this.c5z = new $c_Lpresto_types$Email$$anon$69(this);
    this.c5A = true;
  }
  return this.c5z;
});
$p.cH3 = (function() {
  if ((!this.c5C)) {
    this.c5B = new $c_Lpresto_types$Email$$anon$70(this);
    this.c5C = true;
  }
  return this.c5B;
});
$p.zl = (function() {
  if ((!this.c5M)) {
    this.c5L = new $c_Lpresto_types$Email$$anon$71(this);
    this.c5M = true;
  }
  return this.c5L;
});
$p.a3g = (function(text) {
  var trimmed = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__trim__T(text);
  var at = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__indexOf__I__I(trimmed, 64);
  return ((trimmed.length > 254) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), (("Email too long: '" + trimmed) + "'"))) : (((at <= 0) || (at > 64)) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), (("Invalid email: '" + trimmed) + "'"))) : ((!this.c5y.ae4(trimmed)) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), (("Invalid email: '" + trimmed) + "'"))) : ($m_Lpresto_types$Email$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(trimmed)))));
});
var $d_Lpresto_types$Email$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Email$, "presto.types$Email$", ({
  a0a: 1,
  D: 1
}));
export { $d_Lpresto_types$Email$ as $d_Lpresto_types$Email$ };
var $n_Lpresto_types$Email$;
function $m_Lpresto_types$Email$() {
  if ((!$n_Lpresto_types$Email$)) {
    $n_Lpresto_types$Email$ = new $c_Lpresto_types$Email$();
  }
  return $n_Lpresto_types$Email$;
}
export { $m_Lpresto_types$Email$ as $m_Lpresto_types$Email$ };
/** @constructor */
function $c_Lpresto_types$Email$$anon$71(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Email$$anon$71 as $c_Lpresto_types$Email$$anon$71 };
$p = $c_Lpresto_types$Email$$anon$71.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Email$$anon$71;
/** @constructor */
function $h_Lpresto_types$Email$$anon$71() {
}
export { $h_Lpresto_types$Email$$anon$71 as $h_Lpresto_types$Email$$anon$71 };
$h_Lpresto_types$Email$$anon$71.prototype = $p;
$p.bn = (function(it) {
  try {
    $m_Lpresto_types$Email$();
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(it);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().ak(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.bN = (function(text) {
  return $m_Lpresto_types$Email$().a3g(text);
});
$p.bJ = (function(t) {
  return this.bn(t);
});
var $d_Lpresto_types$Email$$anon$71 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Email$$anon$71, "presto.types$Email$$anon$71", ({
  a0e: 1,
  K: 1
}));
export { $d_Lpresto_types$Email$$anon$71 as $d_Lpresto_types$Email$$anon$71 };
/** @constructor */
function $c_Lpresto_types$Email$$anon$69(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Email$$anon$69 as $c_Lpresto_types$Email$$anon$69 };
$p = $c_Lpresto_types$Email$$anon$69.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_s_Conversion();
$p.constructor = $c_Lpresto_types$Email$$anon$69;
/** @constructor */
function $h_Lpresto_types$Email$$anon$69() {
}
export { $h_Lpresto_types$Email$$anon$69 as $h_Lpresto_types$Email$$anon$69 };
$h_Lpresto_types$Email$$anon$69.prototype = $p;
$p.w = (function(x) {
  $m_Lpresto_types$Email$();
  $m_Lpresto_types$Email$();
  return x;
});
var $d_Lpresto_types$Email$$anon$69 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Email$$anon$69, "presto.types$Email$$anon$69", ({
  a0c: 1,
  cz: 1,
  t: 1
}));
export { $d_Lpresto_types$Email$$anon$69 as $d_Lpresto_types$Email$$anon$69 };
/** @constructor */
function $c_Lpresto_types$Email$$anon$70(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Email$$anon$70 as $c_Lpresto_types$Email$$anon$70 };
$p = $c_Lpresto_types$Email$$anon$70.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_s_Conversion();
$p.constructor = $c_Lpresto_types$Email$$anon$70;
/** @constructor */
function $h_Lpresto_types$Email$$anon$70() {
}
export { $h_Lpresto_types$Email$$anon$70 as $h_Lpresto_types$Email$$anon$70 };
$h_Lpresto_types$Email$$anon$70.prototype = $p;
$p.w = (function(x) {
  $m_Lpresto_types$Email$();
  $m_Lpresto_types$Email$();
  return x;
});
var $d_Lpresto_types$Email$$anon$70 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Email$$anon$70, "presto.types$Email$$anon$70", ({
  a0d: 1,
  cz: 1,
  t: 1
}));
export { $d_Lpresto_types$Email$$anon$70 as $d_Lpresto_types$Email$$anon$70 };
/** @constructor */
function $c_Lpresto_types$Email$$anon$68(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Email$$anon$68 as $c_Lpresto_types$Email$$anon$68 };
$p = $c_Lpresto_types$Email$$anon$68.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Email$$anon$68;
/** @constructor */
function $h_Lpresto_types$Email$$anon$68() {
}
export { $h_Lpresto_types$Email$$anon$68 as $h_Lpresto_types$Email$$anon$68 };
$h_Lpresto_types$Email$$anon$68.prototype = $p;
$p.ct = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.cr = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.co = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.cp = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.cB = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.cs = (function(other) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.b2 = (function(x, y) {
  $m_Lpresto_types$Email$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__compareTo__T__I(x, y);
});
var $d_Lpresto_types$Email$$anon$68 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Email$$anon$68, "presto.types$Email$$anon$68", ({
  a0b: 1,
  N: 1,
  a: 1,
  Q: 1,
  S: 1,
  V: 1
}));
export { $d_Lpresto_types$Email$$anon$68 as $d_Lpresto_types$Email$$anon$68 };
//# sourceMappingURL=presto.types$-Email$.js.map
